import * as analytics from 'Services/requester/analytics';
import escapeRegExp from 'Map/utils/escapeRegExp';
import {origin} from 'Map/endpoints';

const ORIGIN_URL_PATTERN = new RegExp(escapeRegExp(origin));

export default function transformRequestFactory(tiersContainer) {
    return (inputUrl) => {
        let url = inputUrl;
        const tiers = tiersContainer.getTiers();
        for (const tier of tiers) {
            const urlTransformer = tier.getUrlTransformer();
            if (urlTransformer && urlTransformer.test(url)) {
                url = urlTransformer.transform(url);
            }
        }

        const headers = {};
        if (ORIGIN_URL_PATTERN.test(url)) {
            headers[analytics.getHeaderName()] = analytics.getHeaderContent();
        }

        return {
            url,
            headers
        };
    };

}



// WEBPACK FOOTER //
// ./map/configurer/transformRequestFactory.js